
export default function ComplianceSection() {
  const certifications = [
    {
      name: 'QCDD',
      description: 'Qatar Civil Defence Directorate Approved',
      icon: 'ri-shield-check-line'
    },
    {
      name: 'EN54',
      description: 'European Fire Detection Standards',
      icon: 'ri-award-line'
    },
    {
      name: 'UL Listed',
      description: 'Underwriters Laboratories Certified',
      icon: 'ri-verified-badge-line'
    },
    {
      name: 'NFPA',
      description: 'National Fire Protection Association',
      icon: 'ri-fire-line'
    }
  ];

  return (
    <section className="bg-gray-900 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-white mb-4">Compliance & Approvals</h2>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            All FlameGuardQA fire safety products are certified and conform to international standards, 
            ensuring reliability, safety, and regulatory compliance in Qatar.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {certifications.map((cert, index) => (
            <div
              key={index}
              className="text-center p-6 bg-gray-800 rounded-lg hover:bg-gray-700 transition-colors"
            >
              <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${cert.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-2">{cert.name}</h3>
              <p className="text-gray-300 text-sm">{cert.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="inline-flex items-center px-6 py-3 bg-red-600 text-white rounded-lg">
            <i className="ri-shield-check-line mr-2"></i>
            <span className="font-semibold">Fully Compliant with Qatar Fire Safety Regulations</span>
          </div>
        </div>
      </div>
    </section>
  );
}
